module.exports = __webpack_public_path__ + "img/ss.9a15dd43.svg";